import { useDocumentTitle } from '@hooks/index';
import { Translations } from '@translations/translationsTypes';
import { useTranslate } from '@translations/useTranslate';
import { IBSRequestForm } from '@ui/components/organisms/IBSRequestForm';
import React, { FC, useEffect } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';

interface IBSRequestParams {
  languageId: string;
}

interface VisitRequestProps extends RouteComponentProps<IBSRequestParams> {
  param: string;
}

export const IBSRequest: FC<VisitRequestProps> = (props) => {
  const { t, setLanguage } = useTranslate();
  useDocumentTitle(t('page.title.ibs'));
  const history = useHistory();
  useEffect(() => {
    if (props?.match?.params?.languageId) {
      const language =
        props?.match?.params?.languageId === Translations.ar ? Translations.ar : Translations.en;
      setLanguage(language);
      history.replace('/ibs-request');
    }
  }, [history, props?.match?.params?.languageId, setLanguage]);
  return <IBSRequestForm />;
};
